module.exports = __webpack_public_path__ + "img/pin-icon.bd7f07cf.svg";